'use strict';
const _ = require('lodash');

const msgIntent = 'WIX_CODE_SITE_API';
const REPORT_BI_MESSAGE_TYPE = 'reportBI';

function report(sendMsgFunc, reportDef, params) {
  const definition = _.defaults({endpoint: 'platform-viewer'}, reportDef);
  sendMsgFunc({
    intent: msgIntent,
    type: REPORT_BI_MESSAGE_TYPE,
    reportDef: definition,
    params: params
  });
}

module.exports = {
  report: report
};



// WEBPACK FOOTER //
// ./src/main/bi.js